// ============================================================
// VCE — Política de encuadre (función pura)
// ============================================================
// contain SIEMPRE por defecto (P2/P3: la media nunca recorta, nunca
// invade info). cover SOLO si el tenant lo declara explícitamente.
// ============================================================
import type { FitPolicy } from '../types';

export function resolveFit(config?: { fitPolicy?: FitPolicy }): FitPolicy {
  // contain por defecto incondicional; cover requiere declaración explícita
  return config?.fitPolicy === 'cover' ? 'cover' : 'contain';
}

export function isCoverAllowed(config?: { fitPolicy?: FitPolicy }): boolean {
  return config?.fitPolicy === 'cover';
}
